/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils/validators.ts (Authorization Codes)
 🗓️ Created: 2025-01-15
 🧩 Description:
    Form validation utilities for Authorization Codes.

────────────────────────────────────────────────────────────────*/

import { FormState } from '../types';

/**
 * Validate authorization code form
 */
export function validateForm(formData: FormState, domainId: number | null | undefined): Record<string, string> {
  const errors: Record<string, string> = {};

  if (!domainId) {
    errors.domainId = 'Domain is required';
  }

  if (!formData.code.trim()) {
    errors.code = 'Authorization code is required';
  } else if (!/^[A-Za-z0-9_-]{1,16}$/.test(formData.code.trim())) {
    errors.code = 'Authorization code contains invalid characters (allowed: letters, numbers, "-", "_")';
  }

  if (!formData.cosId) {
    errors.cosId = 'Class of Service is required';
  }

  return errors;
}

